import { VERTICALS } from '../../constants/uriConstants.ts';
import { CATEGORY_LEVEL_1 } from '../../utils/categoryHelpers.ts';
import { ATTRIBUTE_ITEMTYPE } from '../../constants/attributesConstants.ts';
import { pageTypeConstants } from '../../constants/pageTypeConstants.ts';
import {
    ART_SIZE,
    JEWELRY_TYPE,
    GENDER,
    PRICE,
    PRICE_TRADE,
    SUBJECT_MATTER,
} from './sbSharedRefineMenuConstants.ts';

export const QUICK_FILTERS_BY_VERTICAL: Record<
    (typeof VERTICALS)[keyof typeof VERTICALS],
    string[]
> = {
    [VERTICALS.ART]: [
        CATEGORY_LEVEL_1,
        PRICE,
        PRICE_TRADE,
        ART_SIZE,
        pageTypeConstants.PERIOD,
        pageTypeConstants.STYLE,
        SUBJECT_MATTER,
        pageTypeConstants.LOCATION,
        pageTypeConstants.CREATOR,
    ],
    [VERTICALS.FASHION]: [
        CATEGORY_LEVEL_1,
        PRICE,
        PRICE_TRADE,
        pageTypeConstants.CREATOR,
        pageTypeConstants.PERIOD,
        GENDER,
        pageTypeConstants.LOCATION,
    ],
    [VERTICALS.FURNITURE]: [
        CATEGORY_LEVEL_1,
        PRICE,
        PRICE_TRADE,
        ATTRIBUTE_ITEMTYPE,
        pageTypeConstants.LOCATION,
        pageTypeConstants.STYLE,
        pageTypeConstants.PERIOD,
        pageTypeConstants.MATERIAL,
        pageTypeConstants.CREATOR,
    ],
    [VERTICALS.JEWELRY]: [
        CATEGORY_LEVEL_1,
        PRICE,
        PRICE_TRADE,
        pageTypeConstants.METAL,
        pageTypeConstants.PERIOD,
        pageTypeConstants.STONE,
        GENDER,
        JEWELRY_TYPE,
        pageTypeConstants.CREATOR,
        pageTypeConstants.STYLE,
    ],
};

export const QUICK_FILTERS_EMPTY_ARRAY: string[] = [];

export const QUICK_FILTER_TRACKING_OPTIONS = { interaction_type: 'quick filter' };
